
import type { ClusterFeature } from '@/modules/YandexMap3Module/map-cluster.types'
import type { ClusterFeatureEntity, DispatcherWorkplaceTake } from '@/modules/DispatcherWorkplaceModule/types'

import type { PropType } from 'vue'

import { defineComponent, reactive } from 'vue'

import DwPopup from '@/modules/DispatcherWorkplaceModule/ui/DwPopup/index.vue'
import DwButton from '@/modules/DispatcherWorkplaceModule/ui/DwButton/index.vue'

import useNotifications from '@/common/composable/useNotifications'

import { dispatcherWorkplaceAPI } from '@/modules/DispatcherWorkplaceModule/services'

export default defineComponent({
    components: {
        DwPopup,
        DwButton,
    },
    props: {
        feature: {
            type: [Object, null] as PropType<ClusterFeature<ClusterFeatureEntity> | null>,
            default: null
        }
    },
    emits: ['close', 'submitted'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
        })

        const onClose = () => {
            if (state.is_loading) return
            emit('close')
        }

        const onSubmit = async () => {
            if (!props.feature || !props.feature.entity || props.feature.entity.type !== 1 || state.is_loading) return

            try {
                state.is_loading = true

                await dispatcherWorkplaceAPI.setSelfDelivery((props.feature.entity as DispatcherWorkplaceTake).orderId)

                notifications.notify({ type: 'success', title: 'Самопривоз назначен' })
                emit('submitted', props.feature)
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При назначении самопривоза произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            onClose,
            onSubmit
        }
    }
})
